var _path, _path2, _path3, _path4, _path5, _path6, _filter;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFigma = function SvgFigma(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M27 96.667V31.333C27 19.083 31.111 15 43.444 15h24.667L101 47.667v49C101 108.917 96.889 113 84.555 113h-41.11C31.11 113 27 108.917 27 96.667",
    style: {
      fill: "#000",
      fillOpacity: 0.08
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg_icon_Figma__filter0_dd_2253_14957)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16",
    style: _defineProperty(_defineProperty({
      fill: "#272727"
    }, "fill", "color(display-p3 .1529 .1529 .1529)"), "fillOpacity", 1)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Figma__paint0_linear_2253_14957)",
    fillOpacity: 0.16,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Figma__paint1_linear_2253_14957)",
    fillOpacity: 0.08,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Figma__paint2_radial_2253_14957)",
    fillOpacity: 0.2,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Figma__paint3_radial_2253_14957)",
    fillOpacity: 0.4,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Figma__paint4_radial_2253_14957)",
    fillOpacity: 0.8,
    d: "M28 96V32c0-12 4-16 16-16h24l32 32v48c0 12-4 16-16 16H44c-12 0-16-4-16-16"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_Figma__clip0_2253_14957)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M56.002 100A8 8 0 0 0 64 92v-8h-7.998a8 8 0 0 0-7.999 8c0 4.416 3.584 8 7.999 8",
    style: _defineProperty(_defineProperty({
      fill: "#0acf83"
    }, "fill", "color(display-p3 .0392 .8118 .5137)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M48.003 76c0-4.416 3.584-8 7.999-8H64v16h-7.998a8 8 0 0 1-7.999-8",
    style: _defineProperty(_defineProperty({
      fill: "#a259ff"
    }, "fill", "color(display-p3 .6353 .349 1)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M48.003 60c0-4.416 3.584-8 7.999-8H64v16h-7.998a8 8 0 0 1-7.999-8",
    style: _defineProperty(_defineProperty({
      fill: "#f24e1e"
    }, "fill", "color(display-p3 .949 .3059 .1176)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M64 52h7.998a8 8 0 0 1 7.999 8c0 4.416-3.584 8-7.999 8H64z",
    style: _defineProperty(_defineProperty({
      fill: "#ff7262"
    }, "fill", "color(display-p3 1 .4471 .3843)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M79.997 76c0 4.416-3.584 8-7.999 8A8 8 0 0 1 64 76c0-4.416 3.583-8 7.998-8a8 8 0 0 1 7.999 8",
    style: _defineProperty(_defineProperty({
      fill: "#1abcfe"
    }, "fill", "color(display-p3 .102 .7373 .9961)"), "fillOpacity", 1)
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z",
    style: _defineProperty(_defineProperty({
      fill: "#272727"
    }, "fill", "color(display-p3 .1529 .1529 .1529)"), "fillOpacity", 1)
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_Figma__paint5_linear_2253_14957)",
    fillOpacity: 0.12,
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.08,
    d: "M68 16s23.054 23.074 32 32H84c-12 0-16-4-16-16z",
    style: {
      fill: "#fff",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_Figma__paint2_radial_2253_14957",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 34 -29.1429 0 85.5 34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_Figma__paint3_radial_2253_14957",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.00012 20.49993 -23.02097 -10.10694 87.5 33.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_Figma__paint4_radial_2253_14957",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135 38.494 32.933)scale(27.5772 18.3848)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Figma__paint0_linear_2253_14957",
    x1: 64,
    x2: 64,
    y1: 16,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Figma__paint1_linear_2253_14957",
    x1: 64,
    x2: 64,
    y1: 16,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_Figma__paint5_linear_2253_14957",
    x1: 84,
    x2: 71.5,
    y1: 31,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_Figma__clip0_2253_14957"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v48H0z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "translate(48 52)"
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "svg_icon_Figma__filter0_dd_2253_14957",
    width: 88,
    height: 112,
    x: 20,
    y: 16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2253_14957"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2253_14957",
    result: "effect2_dropShadow_2253_14957"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2253_14957",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFigma);
export { ForwardRef as ReactComponent };